// Copyright ©️ 2025 eVolve MEP, LLC

import { type ReactNode, useCallback, useMemo } from 'react';

import { useBlockerContext } from 'hooks/navigation/useBlockerContext';

export const useBlocker = <T extends string>(name: T) => {
  const { unblockers, block, registerMessage } = useBlockerContext<T>();
  const registerThisMessage = useCallback(
    (message: ReactNode) => registerMessage(name, message),
    [registerMessage, name],
  );
  const unblocker = unblockers[name];
  const blockByName = useCallback(() => block(name), [block, name]);
  return useMemo(
    () => [blockByName, unblocker, registerThisMessage] as const,
    [blockByName, unblocker, registerThisMessage],
  );
};
